var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderAdd20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5C3 3.89543 3.89543 3 5 3H8.38197C9.13951 3 9.83204 3.428 10.1708 4.10557L10.618 5H14C15.6569 5 17 6.34315 17 8V11H15V8C15 7.44772 14.5523 7 14 7H9.38197L8.38197 5H5V14C5 14.5523 5.44772 15 6 15H11V17H6C4.34315 17 3 15.6569 3 14V5ZM14 13C14 12.4477 14.4477 12 15 12C15.5523 12 16 12.4477 16 13V14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V16H13C12.4477 16 12 15.5523 12 15C12 14.4477 12.4477 14 13 14H14V13Z",
  fill: "currentColor"
})));
export { SvgFolderAdd20 as ReactComponent };